// extracted by mini-css-extract-plugin
export var buttonContainer = "cD_d6";
export var innerContainer = "cD_fh";
export var subtitle = "cD_j";
export var textContainer = "cD_dk";